import { fetchGet } from '../fetch';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const COMPANY_SET = 'COMPANY_SET';

export function setCompany(storageLimit: number, storageUsed: number, percentageUsed: number) {
    return { type: COMPANY_SET, storageLimit, storageUsed, percentageUsed };
}

export function getCompany() {
    return async (dispatch: any) => {
        try {
            const response = await fetchGet('/api/user/company');

            if (response.status >= 500) {
                throw new Error('Bad response from server');
            }

            const { json } = response;
            let percentageUsed = 0;
            if (json.storageLimit > 0 && json.storageUsed > 0) {
                percentageUsed = Math.ceil((json.storageUsed / json.storageLimit) * 100);
            }
            dispatch(setCompany(json.storageLimit, json.storageUsed, percentageUsed));
        } catch (error: any) {
            console.log(error);
        }
    };
}
